import { ActivityReport } from './models/activity-report';
import { ClientGuard } from './guards/client.guards';
import { ExcelService } from './services/excel.service';
import { HeaderComponent } from './components/header/header.component';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, Component, Injectable, APP_INITIALIZER } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MalihuScrollbarModule } from 'ngx-malihu-scrollbar';
import { MultiselectDropdownModule } from 'angular-2-dropdown-multiselect';
import { IonRangeSliderModule } from 'ng2-ion-range-slider';
import { DateTimeAdapter, OWL_DATE_TIME_LOCALE, OwlDateTimeModule, OwlNativeDateTimeModule, OwlDateTimeIntl, OWL_DATE_TIME_FORMATS } from 'ng-pick-datetime';
import { MomentDateTimeAdapter, OwlMomentDateTimeModule, OWL_MOMENT_DATE_TIME_ADAPTER_OPTIONS } from 'ng-pick-datetime-moment';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DataTablesModule } from 'angular-datatables';
import { NgxPermissionsModule, NgxPermissionsService, NgxPermissionsGuard } from 'ngx-permissions';
import { HighchartsChartModule } from 'highcharts-angular';
import { CounterUpModule } from 'angular4-counter-up';

import { AppComponent } from './app.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { LoginComponent } from './components/login/login.component';
import { AuthService } from './services/auth.service';
import { AuthGuard } from './guards/auth.guards';
import { AuthInterceptor } from './inteceptors/auth-interceptor';
import { LogoutComponent } from './components/logout/logout.component';
import { HttpModule } from '@angular/http';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { AdminDatatableComponent } from './components/admin/admin-datatable/admin-datatable.component';
import { AdminViewComponent } from './components/admin/admin-view/admin-view.component';
import { AdminAddComponent } from './components/admin/admin-add/admin-add.component';
import { AdminEditComponent } from './components/admin/admin-edit/admin-edit.component';
import { ClientViewComponent } from './components/client/client-view/client-view.component';
import { ClientDatatableComponent } from './components/client/client-datatable/client-datatable.component';
import { ClientAddComponent } from './components/client/client-add/client-add.component';
import { ClientEditComponent } from './components/client/client-edit/client-edit.component';
import { SchoolDatatableComponent } from './components/school/school-datatable/school-datatable.component';
import { SchoolViewComponent } from './components/school/school-view/school-view.component';
import { SchoolAddComponent } from './components/school/school-add/school-add.component';
import { SchoolEditComponent } from './components/school/school-edit/school-edit.component';
import { BusDatatableComponent } from './components/bus/bus-datatable/bus-datatable.component';
import { BusViewComponent } from './components/bus/bus-view/bus-view.component';
import { BusAddComponent } from './components/bus/bus-add/bus-add.component';
import { BusEditComponent } from './components/bus/bus-edit/bus-edit.component';
import { BusSwapComponent } from './components/bus/bus-swap/bus-swap.component';
import { GeneralActivityReportComponent } from './components/activity-report/general-activity-report/general-activity-report.component';
import { JourneyActivityReportComponent } from './components/activity-report/journey-activity-report/journey-activity-report.component';
// import { ActivityReportDatatableComponent } from './components/activity-report/activity-report-datatable/activity-report-datatable.component';
import { BusEventDatatableComponent } from './components/bus-event/bus-event-datatable/bus-event-datatable.component';
import { PassengerAutoNotifDatatableComponent } from './components/passenger-auto-notif/passenger-auto-notif-datatable/passenger-auto-notif-datatable.component';
import { PassengerManualNotifDatatableComponent } from './components/passenger-manual-notif/passenger-manual-notif-datatable/passenger-manual-notif-datatable.component';
import { PassengerManualNotifAddComponent } from './components/passenger-manual-notif/passenger-manual-notif-add/passenger-manual-notif-add.component';
import { PassengerDatatableComponent } from './components/passenger/passenger-datatable/passenger-datatable.component';
import { PassengerViewComponent } from './components/passenger/passenger-view/passenger-view.component';
import { PassengerAddComponent } from './components/passenger/passenger-add/passenger-add.component';
import { PassengerEditComponent } from './components/passenger/passenger-edit/passenger-edit.component';
import { PassengerArchiveComponent } from './components/passenger/passenger-archive/passenger-archive.component';
import { BusMapComponent } from './components/bus/bus-map/bus-map.component';
import { BusMapJourneyComponent } from './components/bus/bus-map-journey/bus-map-journey.component';
import { PassengerMapComponent } from './components/passenger/passenger-map/passenger-map.component';
import { SchoolService } from './services/school.service';
import { HomeComponent } from './components/home/home.component';
import { PassengerManualNotifShowComponent } from './components/passenger-manual-notif/passenger-manual-notif-show/passenger-manual-notif-show.component';
import { LOCALE_ID } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import localeFrExtra from '@angular/common/locales/extra/fr';
import { TripDatatableComponent } from './components/trip/trip-datatable/trip-datatable.component';
import { TripAddComponent } from './components/trip/trip-add/trip-add.component';
import { TripViewComponent } from './components/trip/trip-view/trip-view.component';
import { TripEditComponent } from './components/trip/trip-edit/trip-edit.component';
import { Select2Module } from 'ng2-select2';
import { PNotifyService } from './services/pnotify.service';
import { AdminLoginComponent } from './components/admin-login/admin-login.component';
import { ResponsibleDatatableComponent } from './components/responsible/responsible-datatable/responsible-datatable.component';
import { ResponsibleAddComponent } from './components/responsible/responsible-add/responsible-add.component';
import { ResponsibleEditComponent } from './components/responsible/responsible-edit/responsible-edit.component';
import { ResponsibleViewComponent } from './components/responsible/responsible-view/responsible-view.component';
import { SynthesisComponent } from './components/planning-and-optimization/synthesis/synthesis.component';
import { JourneyComponent } from './components/planning-and-optimization/journey/journey.component';
import { ReportComponent } from './components/planning-and-optimization/report/report.component';
import { AssignmentsComponent } from './components/planning-and-optimization/assignments/assignments.component';
import { DashboardProComponent } from './components/dashboard/dashboard-pro/dashboard-pro.component';
import { UserManualComponent } from './components/user-manual/user-manual.component';
import { AppLinksComponent } from './components/app-links/app-links.component';
import { PassengerAddlistComponent } from './components/passenger/passenger-addlist/passenger-addlist.component';
import { FuelControlComponent } from './components/fuel-control/fuel-control.component';
import { PassengerSubscriptionComponent } from './components/passenger-subscription/passenger-subscription.component';
import { DashboardEssentielComponent } from './components/dashboard/dashboard-essentiel/dashboard-essentiel.component';
import { DashboardGeoComponent } from './components/dashboard/dashboard-geo/dashboard-geo.component';
import { DepensesEditionComponent } from './components/depenses/depenses-edition/depenses-edition.component';
import { DepensesStatisticsComponent } from './components/depenses/depenses-statistics/depenses-statistics.component';
import { DetailsActivityReportComponent } from './components/activity-report/details-activity-report/details-activity-report.component';
import { SubscriptionListComponent } from './components/subscription/subscription-list/subscription-list.component';
import { SubscriptionAddPassengerComponent } from './components/subscription/subscription-add-passenger/subscription-add-passenger.component';
import { SubscriptionEditPassengerComponent } from './components/subscription/subscription-edit-passenger/subscription-edit-passenger.component';
import { SubscriptionViewPassengerComponent } from './components/subscription/subscription-view-passenger/subscription-view-passenger.component';
import { SubscriptionZonesDistributionComponent } from './components/subscription/subscription-zones-distribution/subscription-zones-distribution.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { PassengerSyncComponent } from './components/passenger/passenger-sync/passenger-sync.component';
import { PushDatatableComponent } from './components/push/push-datatable/push-datatable.component';
import { PushAddComponent } from './components/push/push-add/push-add.component';
import { PushViewComponent } from './components/push/push-view/push-view.component';
import { PushConfigComponent } from './components/push/push-config/push-config.component';
import { PushService } from './services/push.service';



registerLocaleData(localeFr, 'fr-FR', localeFrExtra);

export function initApp(authService: AuthService): Function {
  authService.loadRoles();
  return () => new Promise(resolve => {
    resolve(true);
  });
}
export const MY_NATIVE_FORMATS = {
  fullPickerInput: { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' },
  datePickerInput: { year: 'numeric', month: 'numeric', day: 'numeric' },
  timePickerInput: { hour: 'numeric', minute: 'numeric', second: 'numeric' },
  monthYearLabel: { year: 'numeric', month: 'short' },
  dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
  monthYearA11yLabel: { year: 'numeric', month: 'long' },
};
export const MY_MOMENT_FORMATS = {
  parseInput: 'YYYY-MM-DD HH:mm:ss',
  fullPickerInput: 'DD/MM/YYYY à HH:mm:ss',
  datePickerInput: 'DD/MM/YYYY',
  timePickerInput: 'HH:mm:ss',
  monthYearLabel: 'MMM YYYY',
  dateA11yLabel: 'LL',
  monthYearA11yLabel: 'MMMM YYYY',
};

export class DefaultIntl {
  upSecondLabel = 'Ajouter une seconde';
  downSecondLabel = 'Moins une seconde';
  upMinuteLabel = 'Ajouter une minute';
  downMinuteLabel = 'Moins une minute';
  upHourLabel = 'Ajouter une heure';
  downHourLabel = 'Moins une heure';
  prevMonthLabel = 'Le mois précédent';
  nextMonthLabel = 'Le mois prochain';
  prevYearLabel = 'Année précédente';
  nextYearLabel = 'L\'année prochaine';
  prevMultiYearLabel = '21 dernières années';
  nextMultiYearLabel = '21 prochaines années';
  switchToMonthViewLabel = 'Passer à l\'affichage par mois';
  switchToMultiYearViewLabel = 'Choisissez le mois et l\'année';
  cancelBtnLabel = 'Annuler';
  setBtnLabel = 'Mettre';
  rangeFromLabel = 'De';
  rangeToLabel = 'À';
  hour12AMLabel = 'AM';
  hour12PMLabel = 'PM';
}

const appRoutes: Routes = [
  { path: '', component: HomeComponent, pathMatch: 'full', canActivate: [AuthGuard] },
  {
    path: 'admin',
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      permissions: {
        only: ['ROLE_SUPER_ADMIN'],
        redirectTo: ''
      }
    },
    children: [
      { path: '', redirectTo: 'list', pathMatch: 'full' },
      { path: 'list', component: AdminDatatableComponent },
      { path: 'view/:id', component: AdminViewComponent },
      { path: 'edit/:id', component: AdminEditComponent },
      { path: 'add', component: AdminAddComponent }
    ]
  },
  {
    path: 'account/admin',
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      permissions: {
        only: ['ROLE_ADMIN'],
        redirectTo: ''
      }
    },
    children: [
      { path: '', redirectTo: 'view', pathMatch: 'full' },
      { path: 'view', component: AdminViewComponent },
      { path: 'edit', component: AdminEditComponent }
    ]
  },
  {
    path: 'client',
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      permissions: {
        only: ['ROLE_ADMIN'],
        redirectTo: ''
      }
    },
    children: [
      { path: '', redirectTo: 'list', pathMatch: 'full' },
      { path: 'list', component: ClientDatatableComponent },
      { path: 'view/:id', component: ClientViewComponent },
      { path: 'edit/:id', component: ClientEditComponent },
      { path: 'add', component: ClientAddComponent }
    ]
  },
  {
    path: 'account/client',
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      permissions: {
        only: ['ROLE_CLIENT', 'ROLE_SUPER_CLIENT'],
        redirectTo: ''
      }
    },
    children: [
      { path: '', redirectTo: 'view', pathMatch: 'full' },
      { path: 'view', component: ClientViewComponent },
      { path: 'edit', component: ClientEditComponent }
    ]
  },
  {
    path: 'responsible',
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      permissions: {
        only: ['ROLE_ADMIN'],
        redirectTo: ''
      }
    },
    children: [
      { path: '', redirectTo: 'list', pathMatch: 'full' },
      { path: 'list', component: ResponsibleDatatableComponent },
      { path: 'view/:id', component: ResponsibleViewComponent },
      { path: 'edit/:id', component: ResponsibleEditComponent },
      { path: 'add', component: ResponsibleAddComponent }
    ]
  },
  {
    path: 'account/responsible',
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      permissions: {
        only: ['ROLE_RESPONSIBLE'],
        redirectTo: ''
      }
    },
    children: [
      { path: '', redirectTo: 'view', pathMatch: 'full' },
      { path: 'view', component: ResponsibleViewComponent },
      { path: 'edit', component: ResponsibleEditComponent }
    ]
  },
  { path: 'school/list', component: SchoolDatatableComponent, canActivate: [AuthGuard] },
  { path: 'school/view/:id', component: SchoolViewComponent, canActivate: [AuthGuard] },
  { path: 'school/edit/:id', component: SchoolEditComponent, canActivate: [AuthGuard] },
  {
    path: 'school/add', component: SchoolAddComponent, canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      permissions: {
        only: ['ROLE_ADMIN'],
        redirectTo: ''
      }
    }
  },
  { path: 'bus/list', component: BusDatatableComponent, canActivate: [AuthGuard] },
  { path: 'bus/view/:id', component: BusViewComponent, canActivate: [AuthGuard] },
  { path: 'bus/edit/:id', component: BusEditComponent, canActivate: [AuthGuard] },
  {
    path: 'bus/add', component: BusAddComponent, canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      permissions: {
        only: ['ROLE_ADMIN'],
        redirectTo: ''
      }
    }
  },
  {
    path: 'bus/swap', component: BusSwapComponent, canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      permissions: {
        only: ['ROLE_ADMIN'],
        redirectTo: ''
      }
    }
  },
  {
    path: 'bus/map', component: BusMapComponent, canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      permissions: {
        only: ['ROLE_RESPONSIBLE', 'ROLE_CLIENT', 'ROLE_SUPER_CLIENT'],
        redirectTo: ''
      }
    }
  },
  {
    path: 'bus/mapJourney', component: BusMapJourneyComponent, canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      permissions: {
        only: ['ROLE_RESPONSIBLE', 'ROLE_CLIENT', 'ROLE_SUPER_CLIENT'],
        redirectTo: ''
      }
    }
  },
  {
    path: 'passenger',
    children: [
      { path: '', redirectTo: 'list/:PgNo/:PgLen', pathMatch: 'full' },
      { path: 'list/:PgNo/:PgLen', component: PassengerDatatableComponent, canActivate: [AuthGuard] },
      { path: 'add/:PgNo/:PgLen', component: PassengerAddComponent, canActivate: [AuthGuard] },
      { path: 'addliste', component: PassengerAddlistComponent, canActivate: [AuthGuard] },
      { path: 'sync', component: PassengerSyncComponent, canActivate: [AuthGuard] },
      { path: 'edit/:id/:PgNo/:PgLen', component: PassengerEditComponent, canActivate: [AuthGuard] },
      { path: 'view/:id/:PgNo/:PgLen', component: PassengerViewComponent, canActivate: [AuthGuard] }
    ]
  },
  {
    path: 'passenger/map', component: PassengerMapComponent, canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      permissions: {
        only: ['ROLE_RESPONSIBLE', 'ROLE_CLIENT', 'ROLE_SUPER_CLIENT'],
        redirectTo: ''
      }
    }
  },
  {
    path: 'activityReport',
    children: [
      { path: 'generalActivityReport', component: GeneralActivityReportComponent, canActivate: [AuthGuard] },
      { path: 'journeyActivityReport', component: JourneyActivityReportComponent, canActivate: [AuthGuard] },
      { path: 'detailsActivityReport', component: DetailsActivityReportComponent, canActivate: [AuthGuard] }
    ]

  },
  {
    path: 'depenses',
    children: [
      { path: 'depenses-edition', component: DepensesEditionComponent, canActivate: [AuthGuard] },
      { path: 'depenses-statistics', component: DepensesStatisticsComponent, canActivate: [AuthGuard] }
    ]

  },
  // { path: 'activityReport/list', component: ActivityReportDatatableComponent, canActivate: [AuthGuard] },
  // { path: 'activityReport/journeyReport', component: JourenyReportComponent, canActivate: [AuthGuard] },
  // { path: 'generalActivityReport', component: GeneralActivityReportComponent, canActivate: [AuthGuard] },
  { path: 'passenger/archive', component: PassengerArchiveComponent, canActivate: [AuthGuard] },
  { path: 'fuelControl', component: FuelControlComponent, canActivate: [AuthGuard] },
  {
    path: 'busEvent/list', component: BusEventDatatableComponent, canActivate: [AuthGuard, NgxPermissionsGuard],
    // data: {
    //   permissions: {
    //     only: ['ROLE_ADMIN'],
    //     redirectTo: ''
    //   }
    // }
  },
  {
    path: 'passengerAutoNotif/list', component: PassengerAutoNotifDatatableComponent, canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      permissions: {
        only: ['ROLE_ADMIN'],
        redirectTo: ''
      }
    }
  },
  {
    path: 'passengerManualNotif',
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      permissions: {
        only: ['ROLE_RESPONSIBLE', 'ROLE_CLIENT', 'ROLE_SUPER_CLIENT'],
        redirectTo: ''
      }
    },
    children: [
      { path: '', redirectTo: 'list', pathMatch: 'full' },
      { path: 'list', component: PassengerManualNotifDatatableComponent },
      { path: 'add', component: PassengerManualNotifAddComponent },
      { path: 'view/:id', component: PassengerManualNotifShowComponent }
    ]
  },
  { path: 'trip/list', component: TripDatatableComponent, canActivate: [AuthGuard] },
  { path: 'trip/view/:id', component: TripViewComponent, canActivate: [AuthGuard] },
  { path: 'trip/edit/:id', component: TripEditComponent, canActivate: [AuthGuard] },
  { path: 'trip/add', component: TripAddComponent, canActivate: [AuthGuard] },
  {
    path: 'planning-and-optimization',
    canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: 'synthesis', pathMatch: 'full' },
      { path: 'sync', component: PassengerSyncComponent },
      { path: 'zones', component: SubscriptionZonesDistributionComponent },
      { path: 'assignments', component: AssignmentsComponent },
      { path: 'journey', component: JourneyComponent },
      { path: 'synthesis', component: SynthesisComponent },
      // { path: 'report', component: ReportComponent }
    ]
  },
  {
    path: 'assistant',
    canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: 'list/:PgNo/:PgLen', pathMatch: 'full' },
      { path: 'list/:PgNo/:PgLen', component: PassengerDatatableComponent, data: { isAssistant: true } },
      { path: 'add/:PgNo/:PgLen', component: PassengerAddComponent, data: { isAssistant: true } },
      { path: 'edit/:id/:PgNo/:PgLen', component: PassengerEditComponent, data: { isAssistant: true } },
      { path: 'view/:id/:PgNo/:PgLen', component: PassengerViewComponent, data: { isAssistant: true } }
    ]
  },
  {
    path: 'dashboard/dashboard-pro', component: DashboardProComponent, canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      permissions: {
        only: ['ROLE_RESPONSIBLE', 'ROLE_CLIENT', 'ROLE_SUPER_CLIENT'],
        redirectTo: ''
      }
    }
  },
  {
    path: 'dashboard/dashboard-essentiel', component: DashboardEssentielComponent, canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      permissions: {
        only: ['ROLE_RESPONSIBLE', 'ROLE_CLIENT', 'ROLE_SUPER_CLIENT'],
        redirectTo: ''
      }
    }
  },
  {
    path: 'dashboard/dashboard-geo', component: DashboardGeoComponent, canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      permissions: {
        only: ['ROLE_RESPONSIBLE', 'ROLE_CLIENT', 'ROLE_SUPER_CLIENT'],
        redirectTo: ''
      }
    }
  },  
  {
    path: 'passenger-subscription', component: PassengerSubscriptionComponent, canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      permissions: {
        only: ['ROLE_ADMIN'],
        redirectTo: ''
      }
    }
  },
  {
    path: 'subscription',
    canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: 'subscription-list/:PgNo/:PgLen', pathMatch: 'full' },
      { path: 'subscription-list/:PgNo/:PgLen', component: SubscriptionListComponent },
      { path: 'subscription-add-passenger/:PgNo/:PgLen', component: SubscriptionAddPassengerComponent },
      { path: 'subscription-edit-passenger/:id/:PgNo/:PgLen', component: SubscriptionEditPassengerComponent },
      { path: 'subscription-view-passenger/:id/:PgNo/:PgLen', component: SubscriptionViewPassengerComponent },
      { path: 'subscription-zones-distribution', component: SubscriptionZonesDistributionComponent, canActivate: [AuthGuard] },

      //{ path: 'journey', component: JourneyComponent },
      //{ path: 'assignments', component: AssignmentsComponent },
      // { path: 'report', component: ReportComponent }
    ]
  },
  {
    path: 'push',
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      permissions: {
        only: ['ROLE_ADMIN'],
        redirectTo: ''
      }
    },
    children: [
      { path: '', redirectTo: 'list', pathMatch: 'full' },
      { path: 'list', component: PushDatatableComponent },
      { path: 'add', component: PushAddComponent },
      { path: 'edit/:id', component: PushAddComponent },
      { path: 'view/:id', component: PushViewComponent },
      { path: 'config', component: PushConfigComponent }
    ]
  },
  { path: 'userManual', component: UserManualComponent },
  { path: 'appLinks', component: AppLinksComponent },
  { 
    path: 'logout', 
    children: [
      { path: '', redirectTo: 'school', pathMatch: 'full' },
      { path: 'school', component: LogoutComponent, data: { isSchool: true } },
      { path: 'pro', component: LogoutComponent, data: { isSchool: false } }
    ]
  },
  { path: 'reset-password', component: ResetPasswordComponent },
  { path: 'admin/login', component: AdminLoginComponent },
  { 
    path: 'login', 
    children: [
      { path: '', redirectTo: 'school', pathMatch: 'full' },
      { path: 'school', component: LoginComponent, data: { isSchool: true } },
      { path: 'pro', component: LoginComponent, data: { isSchool: false } }
    ]
  },
  { path: '**', component: NotFoundComponent }
];

@NgModule({
  declarations: [
    AppComponent,
    NotFoundComponent,
    LoginComponent,
    LogoutComponent,
    SidebarComponent,
    HeaderComponent,
    AdminDatatableComponent,
    AdminViewComponent,
    AdminAddComponent,
    AdminEditComponent,
    ClientViewComponent,
    ClientDatatableComponent,
    ClientAddComponent,
    ClientEditComponent,
    SchoolViewComponent,
    SchoolDatatableComponent,
    SchoolAddComponent,
    SchoolEditComponent,
    BusDatatableComponent,
    BusViewComponent,
    BusAddComponent,
    BusEditComponent,
    BusSwapComponent,
    // ActivityReportDatatableComponent,
    BusEventDatatableComponent,
    PassengerAutoNotifDatatableComponent,
    PassengerManualNotifDatatableComponent,
    PassengerManualNotifAddComponent,
    PassengerDatatableComponent,
    PassengerViewComponent,
    PassengerAddComponent,
    PassengerEditComponent,
    BusMapComponent,
    BusMapJourneyComponent,
    PassengerMapComponent,
    HomeComponent,
    PassengerManualNotifShowComponent,
    TripDatatableComponent,
    TripAddComponent,
    TripViewComponent,
    TripEditComponent,
    AdminLoginComponent,
    ResponsibleDatatableComponent,
    ResponsibleAddComponent,
    ResponsibleEditComponent,
    ResponsibleViewComponent,
    SynthesisComponent,
    JourneyComponent,
    ReportComponent,
    AssignmentsComponent,
    DashboardProComponent,
    GeneralActivityReportComponent,
    JourneyActivityReportComponent,
    UserManualComponent,
    AppLinksComponent,
    PassengerAddlistComponent,
    FuelControlComponent,
    PassengerArchiveComponent,
    PassengerSubscriptionComponent,
    DashboardEssentielComponent,
    DashboardGeoComponent,
    DepensesEditionComponent,
    DepensesStatisticsComponent,
    DetailsActivityReportComponent,
    SubscriptionListComponent,
    SubscriptionAddPassengerComponent,
    SubscriptionEditPassengerComponent,
    SubscriptionViewPassengerComponent,
    SubscriptionZonesDistributionComponent,
    ResetPasswordComponent,
    PassengerSyncComponent,
    PushDatatableComponent,
    PushAddComponent,
    PushViewComponent,
    PushConfigComponent,
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    NgxPermissionsModule.forRoot(),
    RouterModule.forRoot(
      appRoutes,
      { enableTracing: true }
    ),
    MalihuScrollbarModule.forRoot(),
    DataTablesModule,
    HttpModule,
    MultiselectDropdownModule,
    IonRangeSliderModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    OwlMomentDateTimeModule,
    BrowserAnimationsModule,
    Select2Module,
    HighchartsChartModule,
    CounterUpModule.forRoot()
  ],
  providers: [
    AuthGuard,
    ClientGuard,
    AuthService,
    {
      provide: APP_INITIALIZER,
      useFactory: initApp,
      deps: [AuthService],
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: OwlDateTimeIntl,
      useClass: DefaultIntl
    },
    {
      provide: LOCALE_ID,
      useValue: 'fr-FR'
    },
    // { provide: OWL_DATE_TIME_FORMATS, useValue: MY_NATIVE_FORMATS },
    { provide: DateTimeAdapter, useClass: MomentDateTimeAdapter, deps: [OWL_DATE_TIME_LOCALE] },
    { provide: OWL_DATE_TIME_FORMATS, useValue: MY_MOMENT_FORMATS },
    // { provide: OWL_MOMENT_DATE_TIME_ADAPTER_OPTIONS, useValue: { useUtc: true } },
    ExcelService,
    SchoolService,
    PNotifyService,
    PushService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts